import React from "react";
import Modal from "react-modal";
import Button from "../Button/Button";
import "./ModalComponent.css";
import { useTranslation } from "react-i18next";

export const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		border: "1px solid var(--borderColor)",
		backgroundColor: "var(--containerBackgroundColor)",
		borderRadius: "10px",
	},
};

const ModalComponent = (props) => {
	const { t } = useTranslation();

	function handleConfirm() {
		props.handleConfirm();
	}

	function handleCancel() {
		props.handleCancel();
	}

	function afterOpenModal() { }

	return (
		props.modalIsOpen && (
			<Modal
				closeTimeoutMS={100}
				isOpen={props.modalIsOpen}
				onAfterOpen={afterOpenModal}
				onRequestClose={handleCancel}
				style={customStyles}
				contentLabel="Modal"
				ariaHideApp={false}
			>
				<div className="modal-content-container">
					{props.icon}
					<h1 className="modal-text">{props.modalText}</h1>
					{props.children}
					<div className="modal-buttons-container">
						{!props.hideConfirmButton && (
							<Button
								hidden={props.hideButtons}
								onClick={handleConfirm}
								label={props.buttonLabel1 || t("common.confirm")}
								disabled={props.disableConfirm}
							/>
						)}
						{!props.hideCancelButton && (
							<Button
								hidden={props.hideButtons}
								className={"button-white"}
								onClick={handleCancel}
								label={props.buttonLabel2 || t("common.cancel")}
							/>
						)}
						{props.customButtons}
					</div>
				</div>
			</Modal>
		)
	);
};

export default ModalComponent;
